<template>
  <div>
    <div class="parent-back" v-if="showPlayer">
      <div @click="showPlayer = false" class="icon-wrapper">
        <i class="menu-icon fa fa-play playIcon"></i>
      </div>
    </div>
    <div v-if="!showPlayer">
      <HlsPlayer
        v-bind:showPlayer.sync="showPlayer"
        :src="live.public_hls"
      ></HlsPlayer>
    </div>
  </div>
</template>
<script>
import HlsPlayer from "@/view/content/widgets/HlsPlayer";
import { mapGetters } from "vuex";
export default {
  name: "PlayerComp",
  data() {
    return {
      showPlayer: true
    };
  },
  props: ["live"],
  computed: {
    ...mapGetters(["program"])
  },
  components: {
    HlsPlayer
  }
};
</script>
<style>
.parent-back {
  background-color: black;
  position: relative;
  min-height: 270px;
  /* width: 560px; */
}
.icon-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
}
.playIcon {
  background-color: #00a1e5;
  border-radius: 50%;
  padding: 1.3rem;
  color: #ffffff;
}
</style>
